module.exports = __webpack_public_path__ + "static/media/bg1.5fd15ab9.jpg";